const defaultValuesCustBuild = [
  { name: "Previously Purchased a Vehicle", status: false },
  { name: "No Services in a Date Range - Previously Purchased", status: false },
  { name: "RO Code", status: false },
  { name: "Never Purchased a Vehicle", status: false },
  { name: "Total Service Count", status: false },
  { name: "Total Spend", status: false },
  { name: "Vehicle Year", status: false },
  { name: "Models", status: false },
  { name: "Makes", status: false },
  { name: "Services in a Date Range", status: false },
  { name: "Year", status: false },
  { name: "Vehicle Models", status: false },
  { name: "Vehicle Makes", status: false },
  { name: "Date Range", status: false },
  { name: "State", status: false },
  { name: "DMA", status: false },
  { name: "Zip Code Radius", status: false },
  { name: "New/Used", status: false },
  { name: "No Services in a Date Range - Previously Serviced", status: false },
  { name: "Recall - Previously Serviced", status: false },
  { name: "Recall - Previously Purchased", status: false },
]

export default defaultValuesCustBuild
